var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',{staticClass:"ad-page"},[_c('r-title',[_vm._v(_vm._s(_vm.instruction.title))]),_c('ad-steps',{attrs:{"steps":_vm.instruction.steps}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }